export const CONFIG = {
  IMAGE_SRC: '//s3.marpple.co/files/u_2798351/2025/7/original/4c10979d97a3a50a1cc2e3f324aa0158f3ed570c1.png',
  IMAGE_ALT: '조각스티커',
};

/*
export const makeUploadTypePreview = () => {
  return html` <div class="maker-bp-option-preview">
    <div class="maker-bp-option-preview__text">${runehtml.preventEscape(TT('flexi_maker::desc'))}</div>
    <div class="maker-bp-option-preview__image">
      <img src="${CONFIG.IMAGE_SRC}" alt="${CONFIG.IMAGE_ALT}" />
    </div>
  </div>`;
};
*/
